"use client";
import { ParticipationWorkspace } from "../../components/desk/participation-workspace";
export function ClueWorkbench() { return <ParticipationWorkspace kind="clue"/>; }
